import { render, staticRenderFns } from "./SoilAnalysis.html?vue&type=template&id=faf725f0&external"
import script from "./SoilAnalysis.js?vue&type=script&lang=js&external"
export * from "./SoilAnalysis.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports